import { combineReducers } from "redux";
import { all, fork } from "redux-saga/effects";
import { accessReducer, AppAccessState } from "./access";
import { authReducer, AuthReducerState, authSaga } from "./auth";
import { menuReducer, MenuReducerState, menuSaga } from "./menu";

export interface IApplicationState {
  auth: AuthReducerState;
  menu: MenuReducerState;
  access: AppAccessState;
}

export const rootReducer = combineReducers<IApplicationState>({
  auth: authReducer,
  menu: menuReducer,
  access: accessReducer,
});

export function* rootSaga() {
  yield all([fork(authSaga), fork(menuSaga)]);
}
